const type = {
    REPORT: 'Report',
    COMMENTS: 'Comments',
    ROLLS: 'Rolls',
    MAXAMOUNTS: 'MaxAmounts',
    UPDATE_APP: 'UPDATE_APP'
}

export default Object.freeze(type)